/**
 * Placeholders the V2 API expands server-side from the caller's own auth context. Use
 * these instead of inlining the ids: a large office holds thousands of accounts and the
 * resulting query string exceeds what browsers and gateways accept.
 *
 * V2 only — the V1 API sends the value through to the database untouched.
 */
export var EQueryFilterAlias;
(function (EQueryFilterAlias) {
    EQueryFilterAlias["ActiveAccountIds"] = "ACTIVE_ACCOUNT_IDS";
})(EQueryFilterAlias || (EQueryFilterAlias = {}));
